<template>
  <page :title="i18n.title">
    <div class="confirm-warp">
      <div class="confirm-info">
        <div class="confirm-title">{{ i18n.pay_label }}</div>
        <div class="confirm-price">{{ currency }}{{ payMode === 'creditcard' ? cabinet.yajin : price }}</div>
        <div class="confirm-icon">
          <img src="../../assets/imgs/icon_tips.png" />
          <span>{{ payType === 'YJ' ? i18n.price_tips : i18n.auth_tips.format(currency, price) }}</span>
        </div>
      </div>
      <div class="confirm-payment-label">
        <span>{{ i18n.pay_type }}</span>
      </div>
      <div class="confirm-payment">
        <div class="addcard" @click="saveCard()">
          <div class="left">
            <img src="../../assets/imgs/icon_coupon.png" alt="">
            <span class="addcard-msg">{{ i18n.addcard }}</span>
          </div>
          <img src="../../assets/imgs/icon_more.png" alt="">
        </div>
        <div class="confirm-scroll-y">
          <div class="confirm-card-list" :class="{ 'selected': payMode.pId === item.pId }" v-for="item in cardList"
            :key="item.pId" @click="payMode = item">
            <p class="value" v-if="item.pType === 'Monei'">
              <img src="../../assets/imgs/icon_monei.png" style="height: 30px;" />
              <span>****{{ item.pCardnumber }}</span>
            </p>
            <p class="value" v-else>
              <span class="pBrand">{{ item.pBrand }}</span>
              <span>****{{ item.pCardnumber }}</span>
            </p>
            <p class="date">
              <span @click="removeCardConfirm(item.pId)">{{ i18n.deletecard }}</span>
              {{ item.pExpirationdate }}
            </p>
          </div>
        </div>
        <!-- <div class="confirm-payment-item" v-for="item in payMethodList" :key="item.pId" @click="payMode=item">
          <div class="confirm-payment-item-info">
            <img src="../../assets/imgs/wallet.png" />
            <div class="content">
              <div class="title">{{ item.pPaymentType }}</div>
            </div>
          </div>
          <div class="confirm-payment-item-checked">
            <img v-if="payMode.pPaymentType===item.pPaymentType" src="../../assets/imgs/checkbox_selected.png" />
            <img v-else src="../../assets/imgs/checkbox.png" />
          </div>
        </div> -->
      </div>
      <div class="confirm-btns">
        <div class="btn" @click="onPay()" :disabled="disabled">{{ i18n.submit }}</div>
      </div>
      <popup-warp v-model="isCreditcard">
        <div>
          <div class="creditcard-input">
            <div id="credit-card-element"></div>
          </div>
          <div class="btn creditcard-btn" @click="onStripeSetup">{{ i18n.paynow }}</div>
        </div>
      </popup-warp>
      <popup-warp v-model="MPESAPhoneShow">
        <div class="confirm-row">
          <div class="area" @click="isAreaView = true">
            <span>+{{ areaCode }}</span>
            <div class="area-down"></div>
          </div>
          <input type="number" v-model="phone" :placeholder="$t('login.phone_number')">
        </div>
        <div class="btn creditcard-btn" @click="onPopupPay">{{ i18n.paynow }}</div>
      </popup-warp>
    </div>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
  </page>
</template>

<script>
import { SelectArea } from '../../components/select'
import { debounce } from '../../utils/index'
import { mapState } from 'vuex'
import { getToken } from '../../utils/stripe_pay.js'
import {
  STRIPE_PREPAY_SPTOKEN, STRIPE_PAYORDER_SPTOKEN, PAYPAL_PRE_PAY, PAYPAL_RECHARGE, STRIPE_PREAUTH_OF_CONFIRM, STRIPE_PREAUTH_AUTO_CONFIRM, PAYMODE,
  STRIPE_PAYORDER, STRIPE_RECHARGE_WALLET, MPESA_DEPOSIT_RENT, SAVE_CARD, USER_CARD, STRIPE_SAVE_CARD, STRIPE_SAVE_CARD_CONFIRM,
  MPESA_RECHARGE, MPESA_PAYORDER, MPESA_PAYCONFIRM, SAVED_CARD_RENT, REMOVE_CARD
} from '../../apis/payment'
import { QR_CODE } from '../../apis/cabinet.js'
import stripeMixin from '../../mixins/stripe'
import moneiMixin from '../../mixins/monei'
import { PopupWarp } from '../../components/popup'
export default {
  mixins: [stripeMixin, moneiMixin],
  components: {
    PopupWarp,
    SelectArea
  },
  computed: {
    ...mapState(['system', 'browser', 'cabinet', 'user', 'qrcode', 'wallet', 'agentId']),
    i18n() {
      return this.$t('confirm')
    },
    i18nMsg() {
      return this.$t('msg')
    },
    currency() {
      if (this.cabinet) {
        return this.cabinet.currencyName
      } else {
        return '€'
      }
    }
  },
  watch: {
    payMode(val, oldVal) {
      console.log('payMode', val)
      if (val === 'APPLE_PAY' || val === 'STRIPE_APPLE' || val === 'STRIPE_GOOGLE' || val === 'GOOGLE_PAY') {
        if (!this.stripePayRequest) {
          this.disabled = true
          this.$loading(true)
          this.getStripeToken()
        } else {
          this.disabled = false
        }
      } else {
        this.disabled = false
      }
    },
    stripePayRequest(val, oldVal) {
      this.disabled = !val
    },
    // 绑卡完成后 result 页 $router.replace 回 /confirm 时组件被复用、created 不重跑，
    // 靠此 watcher 检测路由变化并刷新卡列表
    // 注意：Vue 2 中监听 $route 必须用字符串 key '$route'，方法简写 $route(to,from){} 不会被注册
    '$route'(to, from) {
      if (to.path === '/confirm' && from.path === '/result' && this.pDailiId) {
        this.getCardList()
      }
    }
  },
  data() {
    return {
      areaCode: '254',
      price: 0,
      payType: 'YJ',
      formId: '',
      cabinetID: '',
      yaJinType: null,
      pDailiId: '',
      payMode: 'STRIPE_CARD',
      pId: '', // 代理或平台支付配置id
      currencySymbol: '$',
      country: 'US', // 国家
      currencyname: 'usd', // 货币类型
      publicKey: '', // 支付通道的公钥
      disabled: false,
      stripePayRequest: null,
      isCreditcard: false,
      cardStyle: {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      },
      creditcard: null,
      clientSecret: null,
      MPESAPhoneShow: false,
      isAreaView: false,
      payModeList: [],
      orderId: '',
      phone: '',
      creditOrder: null,
      payListShow: false,
      cardList: [],
      cardMode: null,
      cardRetryCount: 0, // 绑卡回跳后拉卡为空的延迟重试次数
      currentPayChannel: '' // 当前支付通道标识（如 'Monei', 'STRIPE_CARD' 等）
    }
  },
  methods: {
    getCardList() {
      this.$loading(true)
      this.$get(
        `${USER_CARD}?status=1&agentId=${this.pDailiId}`,
        {},
        resp => {
          this.$loading(false)
          console.log('cardlist', resp)
          this.cardList = resp.data
          if (resp.data && resp.data.length > 0) {
            this.cardMode = resp.data[0]
          } else {
            this.cardMode = null
            // 绑卡回跳时后端未等 webhook 落库卡就 302 回本页，首拉为空属时序现象，
            // 带 moneiSaveCardSuccess 标记时延迟重拉（限 2 次）等 webhook 完成落库
            if (this.$route.query.moneiSaveCardSuccess && this.cardRetryCount < 2) {
              this.cardRetryCount++
              setTimeout(() => {
                this.getCardList()
              }, 2000)
            }
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.getCardList()
          })
          console.log(error)
        }
      )
    },
    saveCard() {
      // MONEI 通道：走 HPP 绑卡流程
      if (this.currentPayChannel === 'Monei') {
        this.moneiSaveCard(this.pId)
        return
      }
      this.$loading(true)
      this.$post(
        STRIPE_SAVE_CARD + `?paymentId=${this.pId}`, {},
        resp => {
          this.$loading(false)

          this.creditOrder = resp.data
          this.onLoadElement()
          console.log('saveCard====', resp)
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nMsg.msg_fail_title,
            content: error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.saveCard()
          })
          console.log(error)
        },
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }
      )
    },
    onStripeSetup() {
      const vm = this
      vm.$loading(true)
      let pid = this.pId
      let url = this.cabinet.qrcode ? `${window.location.origin}#/confirm?price=${this.price}&payType=${this.payType}&cabinetID=${this.cabinetID}&yaJinType=${this.yaJinType}&paymentId=${pid}&pmid=${this.creditOrder.paymentId}` : `${window.location.origin}#/confirm?paymentId=${pid}&pmid=${this.creditOrder.paymentId}`
      window.stripe.confirmSetup({
        elements: this.creditcard,
        confirmParams: {
          return_url: url
        }
      }).then((result) => {
        console.log(result)
        vm.$loading(false)
        if (result.error) {
          vm.$toast(result.error.message)
        } else {
          console.log('成功====', result)
        }
      })
    },
    onLoadElement() {
      const options = {
        clientSecret: this.creditOrder.clientSecret,
        appearance: {
          theme: 'stripe'
        }
      }
      if (window.stripe) {
        // this.loadStripeScript(this.payMode.publicKey)
        this.creditcard = window.stripe.elements(options)
        const paymentElement = this.creditcard.create('payment')
        this.isCreditcard = true
        this.payListShow = false
        paymentElement.mount('#credit-card-element')
      } else {
        this.$toast('loading...')
        this.loadStripeScript()
        setTimeout(() => {
          this.onLoadElement()
        }, 500)
      }
    },
    onSelct(val) {
      this.areaCode = val
    },
    // 支付方式选中
    onPayMode(v) {
      console.log('支付方式===', v)
      this.payMode = v.pPaymentType
      this.currencySymbol = v.currencySymbol
      this.currencyname = v.configDetails.currency
      this.publicKey = process.env.VUE_APP_STRIPE_ID
      this.country = v.configDetails.accountCountry
    },
    getStripeToken() {
      getToken(this.price, this.country, this.currencyname, this.onStripe)
        .then(data => {
          console.log('stripe getToken', data)
          this.stripePayRequest = data
          this.$loading(false)
        })
        .catch(error => {
          this.stripePayRequest = null
          console.log('stripe getTokenerr', error)
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_support,
            showCancel: false,
            confirmText: this.i18n.msg_fail_confirm
          })
        })
    },
    // apple和Google支付时调用
    onStripe(token, ev) {
      let url = ''
      let datas = {}
      if (this.cabinet && this.payType === 'YJ') {
        url = STRIPE_PREPAY_SPTOKEN
        datas = {
          qrcode: this.cabinet.qrcode,
          stripeToken: token, // stripe官方支付的一次性token
          paymentId: this.pId // 代理或平台支付配置id
        }
      } else if (this.price > 0 && this.payType === 'FK') {
        url = STRIPE_PAYORDER_SPTOKEN
        datas = {
          outTradeNo: this.orderId,
          couponNo: null,
          stripeToken: token,
          paymentId: this.pId
        }
      } else {
        this.$confirm({
          title: this.i18nMsg.title,
          content: this.i18nMsg.error,
          confirmText: this.i18nMsg.confirm,
          showCancel: false
        }).then(() => {
          this.$router.push('/')
        })
      }
      this.$post(
        url,
        datas,
        resp => {
          if (ev && ev.complete) {
            ev.complete('success')
          }
          this.$loading(false)
          console.log(resp)
          if (this.payType === 'CZ') {
            this.$confirm({
              title: this.i18nMsg.title,
              content: this.i18nMsg.success_payment,
              confirmText: this.i18nMsg.confirm,
              showCancel: false
            }).then(() => {
              this.$router.replace('/mine')
            })
          } else {
            this.$toast(this.i18nMsg.success_payment)
            if (this.payType === 'FK') {
              this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=stripe&payType=FK`)
              return
            }
            this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=stripe`)
          }
        },
        error => {
          if (ev && ev.complete) {
            ev.complete('fail')
          }
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          })
        }
      )
    },
    onPopupPay() {
      if (this.payMode === 'M-PESA') {
        // this.onSMSPay()
      }
    },
    LazyLoad: debounce((vm) => {
      if (vm.cardList && vm.cardList.length > 0) {
        // 已保存卡：根据 pType 分流（后端返回的卡数据里用 pType 标识通道）
        if (vm.cardMode && vm.cardMode.pType === 'Monei') {
          vm.moneiOnPay()
        } else {
          vm.onCreditcard()
        }
      } else {
        // 无已保存卡：根据当前支付通道分流
        if (vm.currentPayChannel === 'Monei') {
          vm.moneiOnPay()
        } else {
          vm.saveCard()
        }
      }
    }, 500),
    onPay() {
      this.LazyLoad(this)
    },
    /**
     * MONEI 支付分发
     * 根据是否有已保存卡和 payType 选择不同的 MONEI 接口
     */
    moneiOnPay() {
      // 后端返回的卡数据里用 pType 标识通道（不是 paymentWay）
      const hasSavedMoneiCard = this.cardMode && this.cardMode.pType === 'Monei'
      // 已保存卡：paymentConfigId 用卡自身的 pPaymentId（对齐 Flutter），保证 apiKey 与 paymentToken 同账户
      const paymentConfigId = hasSavedMoneiCard && this.cardMode.pPaymentId ? this.cardMode.pPaymentId : this.pId
      if (this.payType === 'FK' || this.payType === 'PO') {
        // 订单付款
        const outTradeNo = this.orderId
        const userCardId = hasSavedMoneiCard ? this.cardMode.pId : undefined
        this.moneiPayOrder({ outTradeNo, paymentConfigId, userCardId })
      } else {
        // 租借预授权 (YJ)，qrcode 取值逻辑与 getPayMode 保持一致
        const params = {
          qrcode: this.qrcode || this.cabinetID,
          paymentConfigId
        }
        if (hasSavedMoneiCard) {
          params.userCardId = this.cardMode.pId
        }
        this.moneiCreatePay(params)
      }
    },
    removeCardConfirm(id) {
      this.$confirm({
        title: this.i18n.msg_fail_title,
        content: this.i18nMsg.deletecard,
        confirmText: this.i18nMsg.confirm,
        cancelText: this.i18nMsg.cancel
      }).then(() => {
        this.removeCard(id)
      })
    },
    removeCard(id) {
      this.$loading(true)
      this.$get(
        `${REMOVE_CARD}/${id}`,
        {},
        resp => {
          this.$loading(false)
          console.log('removecard====', resp)
          this.isConfirm = false
          this.getCardList()
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.removeCard(id)
          })
          console.log(error)
        }
      )
    },
    onSMSCheckOrder(tradeNo) {
      this.loading = true
      this.$get(
        `${MPESA_PAYCONFIRM}?outTradeNo=${tradeNo}`,
        {},
        resp => {
          if (resp.data && resp.data.orderStatus !== 0) {
            // this.onSMSRent()
          } else {
            this.$confirm({
              title: this.i18nMsg.title,
              content: this.$t('result.msg_fail_content'),
              confirmText: this.i18nMsg.confirm,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.onSMSCheckOrder(tradeNo)
            })
          }
        },
        error => {
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.$t('result.msg_fail_content'),
            confirmText: this.i18nMsg.confirm,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.onSMSCheckOrder(tradeNo)
          })
          // if (error === '正在请求中') {
          //   setTimeout(() => {
          //     this.onSMSCheckOrder(tradeNo)
          //   }, 1000)
          // } else {
          console.log(error)
          //   this.$toast(error)
          // }
        }
      )
    },
    // 卡租借
    onCreditcard(publicKey) {
      this.$loading(true)
      this.$post(
        `${SAVED_CARD_RENT}/${this.cabinet.qrcode}`,
        {
          cardId: this.cardMode.pId
          // paymentId: this.agentId
        },
        resp => {
          this.$loading(false)
          console.log(resp)
          if (resp.data.outTradeNo) {
            this.$router.push(`/result?tradeNo=${resp.data.outTradeNo}`)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            })
          }
        },
        error => {
          this.$loading(false)
          this.$toast(error)
        })
    },
    confirmSetup(id, paymentMethod) {
      this.$loading(true)
      this.$get(
        // `${STRIPE_PREAUTH_AUTO_CONFIRM}`,
        `${STRIPE_PREAUTH_AUTO_CONFIRM}?tradeNo=${id}&orderType=${this.payType === 'YJ' ? 'preAuth' : 'czOrder'}&paymentMethod=${paymentMethod}`,
        {
          outTradeNo: this.clientSecret.outTradeNo
        },
        resp => {
          this.$loading(false)
          this.isCreditcard = false
          if (this.payType !== 'YJ') {
            this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=stripe&payType=${this.payType}`)
            return
          }
          this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=stripe`)
          console.log(resp)
        },
        error => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    onConfirmSaveCard(pid, id) {
      this.$loading(true)
      this.$post(
        STRIPE_SAVE_CARD_CONFIRM,
        {
          paymentId: pid,
          paymentMethod: id
        },
        resp => {
          this.$loading(false)
          console.log('saveCardConfirm====', resp)
          this.getCardList()
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nMsg.msg_fail_title,
            content: error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.onConfirmSaveCard(pid, id)
          })
          console.log(error)
        }
      )
    },
    getPayMode() {
      console.log('hahah', this.cabinet, this.wallet)
      this.$loading(true)
      this.$get(
        this.payType !== 'CZ' ? `${PAYMODE}${`?id=${this.qrcode || this.cabinetID}`}` : `${PAYMODE}?agentId=${this.wallet ? this.wallet.pDailiId : this.cabinet.userWallet.pDailiId}`,
        {},
        resp => {
          this.$loading(false)
          console.log(resp)
          if (resp.data) {
            let list = resp.data
            list.map((v, i, arr) => {
              if (v.pPaymentType === 'STRIPE_CARD') {
                v.label = 'Credit Card'
                v.phone = 'all'
              } else if (v.pPaymentType === 'APPLE_PAY' || v.pPaymentType === 'STRIPE_APPLE') {
                v.label = 'Apple Pay'
                v.phone = 'ios'
              } else if (v.pPaymentType === 'GOOGLE_PAY' || v.pPaymentType === 'STRIPE_GOOGLE') {
                v.label = 'Google Pay'
                v.phone = 'android'
              } else if (v.pPaymentType === 'M-PESA') {
                v.label = 'SMS Payment'
                v.phone = 'all'
              } else if (v.pPaymentType === 'Monei') {
                v.label = 'Credit Card'
                v.phone = 'all'
              }
              // list.push(v)
            })
            this.payModeList = list
            if (list.length > 0) {
              // let item = list.filter(v => {
              //   return v.pPaymentType === 'STRIPE_CARD'
              // })
              this.payMode = list[0].pPaymentType
              this.currencySymbol = list[0].currencySymbol // 货币符号
              this.currencyname = list[0].configDetails.currency // 货币类型
              this.publicKey = list[0].publicKey
              this.pId = list[0].pId
              this.country = list[0].configDetails.accountCountry
              this.pDailiId = list[0].pDailiId
              this.currentPayChannel = list[0].pPaymentType
              console.log(this.publicKey, this.payMode)
              if (list[0].pPaymentType !== 'M-PESA' && list[0].pPaymentType !== 'Monei') {
                this.loadStripeScript(list[0].publicKey)
              }
            }
            // 卡列表依赖 pDailiId（agentId 传真实值后端才会同步 MONEI 等通道的已存卡），等配置就绪后再拉取
            if (this.$route.query.moneiSaveCardSuccess) {
              // 绑卡回跳：后端卡落库依赖异步 webhook，立即拉卡必为空，
              // 保持加载态 5 秒等 webhook 完成落库后再拉取；首拉仍空由 getCardList 内重试兜底
              this.$loading(true)
              setTimeout(() => {
                this.getCardList()
              }, 5000)
            } else {
              this.getCardList()
            }
            console.log('list======', list)
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.getPayMode()
          })
          console.log(error)
        }
      )
    }
  },
  created() {
    // MONEI HPP 返回检测：MONEI 无浏览器重定向（Flutter 靠 WebView 拦截 /receipt 关闭），
    // WAP 整页跳转后用户支付完成会停在 MONEI 回执页，手动返回（浏览器回退）时
    // 存在未确认的支付/绑卡，直接跳 result 页轮询确认
    let moneiOutTradeNo = sessionStorage.getItem('monei_outTradeNo')
    let moneiAction = sessionStorage.getItem('monei_action')
    // 清理前先取出跳转前保存的原始路由参数，用于回跳参数被 MONEI 转义污染时的恢复
    let moneiSavedQuery = sessionStorage.getItem('monei_returnQuery')
    if (moneiAction === 'saveCard') {
      // 绑卡走 redirectToResult 自动回跳本页闭环（moneiSaveCardSuccess=1），残留标记直接清理
      sessionStorage.removeItem('monei_outTradeNo')
      sessionStorage.removeItem('monei_payType')
      sessionStorage.removeItem('monei_action')
      sessionStorage.removeItem('monei_returnQuery')
    } else if (moneiOutTradeNo) {
      // 残留单柜机与本次扫码柜机不一致时视为历史残留（如支付后未回 WAP 收尾就归还再扫别的柜机），
      // 清理后按新租借继续，避免被 replace 去旧单号的 result 页直接展示上次的弹宝结果
      let staleResidual = false
      try {
        let residualCabinetID = moneiSavedQuery ? JSON.parse(moneiSavedQuery).cabinetID : ''
        let currentCabinetID = this.$route.query.cabinetID
        staleResidual = !!residualCabinetID && !!currentCabinetID && residualCabinetID !== currentCabinetID
      } catch (e) {
        console.log('monei_returnQuery parse error', e)
      }
      if (staleResidual) {
        sessionStorage.removeItem('monei_outTradeNo')
        sessionStorage.removeItem('monei_payType')
        sessionStorage.removeItem('monei_action')
        sessionStorage.removeItem('monei_returnQuery')
        // 局部变量同步置空，防止下方按旧单参数恢复现场造成串单
        moneiSavedQuery = null
      } else {
        let moneiPayType = sessionStorage.getItem('monei_payType')
        this.$router.replace(`/result?payMode=monei&payType=${moneiPayType || ''}`)
        return
      }
    }
    // MONEI 往返 completeUrl 时可能把参数中的 & 转义成 &amp; 实体（参数名损坏成 amp;payType），
    // 关键参数 payType 缺失时用跳转前保存的原始参数恢复现场
    let query = this.$route.query
    if (query.payType === undefined && moneiSavedQuery) {
      try {
        query = Object.assign({}, JSON.parse(moneiSavedQuery), query)
        console.log('monei query recovered', JSON.stringify(query))
      } catch (e) {
        console.log('monei_returnQuery parse error', e)
      }
    }
    let price = query.price
    let formId = query.formId
    this.price = price ? Number(price) : 0
    this.orderId = query.outTradeNo
    this.formId = formId
    this.payType = query.payType
    this.cabinetID = query.cabinetID
    this.yaJinType = query.yaJinType
    this.getPayMode()
    let { paymentId, pmid } = query
    if (paymentId) {
      this.onConfirmSaveCard(paymentId, pmid)
    }
  }
}
</script>

<style lang="less">
.noClick {
  opacity: 0.5;
  pointer-events: none;
  /* 禁止鼠标点击 */
}

.confirm-warp {
  overflow-y: scroll;
}

.confirm-info {
  background: #ffffff;
  text-align: center;
  padding: 40px;
}

.confirm-title {
  font-size: 36px;
}

.confirm-price {
  font-size: 80px;
  color: #fc0d1b;
}

.confirm-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }

  & span {
    text-align: left;
    font-size: 28px;
    color: #999999;
  }
}

.confirm-payment {
  background: #ffffff;
  padding: 30px;

  .addcard {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-radius: 20px;
    box-shadow: 3px 6px 10px #e8e8e8;

    .left {
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        margin-right: 20px;
      }
    }

    img {
      width: 40px;
      height: 40px;
    }
  }

  .confirm-scroll-y {
    max-height: 760px;
    margin: 20px 0 0;
    overflow-y: scroll;
  }

  .confirm-card-list {
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 3px 6px 10px #e8e8e8;
    padding: 10px 20px;
    margin: 20px 0;

    p {
      margin: 15px 0;
    }

    .value {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #00904A;
      font-weight: 500;

      .pBrand {
        font-size: 40px;
      }
    }

    .date {
      color: #999;
      text-align: end;
    }
  }

  &-label {
    padding: 10px 20px;
    font-size: 28px;
    color: #999999;
    background: #f7f7f7;
  }

  &-item {
    display: flex;
    align-items: center;
    padding: 20px;
    // border-bottom: 1px solid #dddddd;
    border-radius: 20px;
    box-shadow: 3px 6px 10px #e8e8e8;
    margin: 20px 0;

    & img {
      width: 40px;
      height: 40px;
    }

    &-info {
      display: flex;
      align-items: center;
      flex: 1;

      & .content {
        padding-left: 10px;
      }

      & .sub_title {
        font-size: 28px;
        color: #fec348;
      }
    }
  }
}

.confirm-remark {
  padding: 0 32px;
}

.confirm-remark .title {
  margin-top: 40px;
  font-size: 32px;
}

.confirm-remark .desc {
  font-size: 28px;
  color: rgba(102, 102, 102, 1);
  font-weight: 400;
  word-break: normal !important;
  white-space: normal !important;
}

.confirm-btns {
  padding: 60px 40px 20px;
}

.confirm-btns .btn {
  margin-top: 20px;
}

/* #ifdef MP-WEIXIN */
.confirm-btns button.btn {
  background-color: #65b74e;
}

/* #endif */
.confirm-checkbox {
  padding: 30px;

  & label {
    display: flex;
    align-items: center;
  }

  & span {
    color: #52ac7a;
  }
}

.btn-paypal {
  background: #fec348 !important;
}

.btn-paypal img {
  width: 277px;
  height: 60px;
  margin: 18px 0;
}

.btn-applepay {
  background: #ffffff !important;
  color: #050608;
}

.btn-applepay img {
  width: 143px;
  height: 60px;
  margin: 18px 0;
}

.btn-googlepay {
  color: #5f6368;
  background: #ffffff !important;
}

.btn-googlepay img {
  width: 145px;
  height: 60px;
  margin: 18px 0;
}

.creditcard-input {
  margin: 48px 48px 200px;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #e4e7ed;
}

.creditcard-btn {
  margin: 48px;
}

.confirm-row {
  margin: 36px 45px 140px;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 4px solid rgb(211, 211, 211);
  border-radius: 20px;

  .area {
    width: 100px;
    padding: 0 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  input {
    font-size: 32px;
    width: 300px;
    flex: 1;
    height: 80px;
    padding: 0 20px;
    margin: 0;
    border: none;
    outline: none;
    background-color: rgba(0, 0, 0, 0);
  }

  .area-down {
    // margin-left: 10px;
    width: 0;
    height: 0;
    border-width: 10px 10px 0;
    border-style: solid;
    border-color: black transparent transparent;
  }

  .login-code {
    width: 180px;
    height: 60px;
    background-image: linear-gradient(to right, rgba(194, 194, 194, 1), rgba(252, 252, 252, 1));

    img {
      width: 180px;
      height: 60px;
    }
  }
}
</style>
